import Home from '../pages/home';
// 全局配置文件
const { routes } = window.globalConfig; 

// 路由导航
export const routers = [
    {
        path: routes[0]['path'],
        index: true,
        nameZH: routes[0]['nameZH'], // 中文
        nameEN: routes[0]['nameEN'], // 英文
        element: <Home />,
    },
];

